import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = {
  key: 0,
  class: "field has-addons"
}
const _hoisted_3 = { class: "control" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "control" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-edit has-text-primary" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "control" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-minus has-text-danger" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModelPicker = _resolveComponent("ModelPicker")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("input", {
              class: "input",
              disabled: "",
              value: _ctx.modelDisplayString
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modelsModal = true)),
              title: "Select another model",
              class: "button",
              type: "button"
            }, _hoisted_7)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createElementVNode("button", {
              class: "button",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', ''))),
              title: "Remove model"
            }, _hoisted_10)
          ])
        ]))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "button",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelsModal = true))
        }, " Select model ")),
    _createVNode(_component_Modal, {
      modelValue: _ctx.modelsModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelsModal) = $event)),
      title: "Select a model"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModelPicker, {
          "compatible-worker-id": _ctx.workerId,
          modelValue: _ctx.modelId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelId) = $event))
        }, null, 8, ["compatible-worker-id", "modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}